import { OperationParameter, OperationURLParameter } from "@azure/core-client";
import {
  BasketItemRequest as BasketItemRequestMapper,
  BasketItemUpdateRequest as BasketItemUpdateRequestMapper,
  BasketCheckoutRequest as BasketCheckoutRequestMapper,
  DDAccountVerifyRequest as DDAccountVerifyRequestMapper,
  PostcodeTicketVerifyRequest as PostcodeTicketVerifyRequestMapper
} from "../models/mappers";

export const contentType: OperationParameter = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
};

export const body: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: BasketItemRequestMapper
};

export const accept: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};

export const $host: OperationURLParameter = {
  parameterPath: "$host",
  mapper: {
    serializedName: "$host",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};

export const id: OperationURLParameter = {
  parameterPath: "id",
  mapper: {
    serializedName: "id",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const body1: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: BasketItemUpdateRequestMapper
};

export const itemId: OperationURLParameter = {
  parameterPath: "itemId",
  mapper: {
    serializedName: "itemId",
    required: true,
    type: {
      name: "Number"
    }
  }
};

export const body2: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: BasketCheckoutRequestMapper
};

export const openIDToken: OperationParameter = {
  parameterPath: "openIDToken",
  mapper: {
    serializedName: "openIDToken",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const contentType1: OperationParameter = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "multipart/form-data",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
};

export const image: OperationParameter = {
  parameterPath: ["options", "image"],
  mapper: {
    serializedName: "image",
    type: {
      name: "Stream"
    }
  }
};

export const accept1: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};

export const basketId: OperationParameter = {
  parameterPath: "basketId",
  mapper: {
    serializedName: "basketId",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const itemId1: OperationParameter = {
  parameterPath: "itemId",
  mapper: {
    serializedName: "itemId",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const quantityIndex: OperationParameter = {
  parameterPath: "quantityIndex",
  mapper: {
    serializedName: "quantityIndex",
    required: true,
    type: {
      name: "Number"
    }
  }
};

export const accept2: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "image/png, image/jpeg, application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};

export const body3: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: DDAccountVerifyRequestMapper
};

export const body4: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: PostcodeTicketVerifyRequestMapper
};
